import { render } from "./ModerationTab.vue?vue&type=template&id=5169fe2e&scoped=true"
import script from "./ModerationTab.vue?vue&type=script&lang=js"
export * from "./ModerationTab.vue?vue&type=script&lang=js"

import "./ModerationTab.vue?vue&type=style&index=0&id=5169fe2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5169fe2e"]])

export default __exports__